module.exports = __webpack_public_path__ + "static/media/pan_incorrect_placed.248a584a.svg";